import React, { PureComponent } from 'react';
import Popup from "./Popup";

class ButtonEliminar extends PureComponent {
    constructor(props) {
        super(props);
    }


    render() {
        const { ajuste, eliminarAjuste, usuarioModif } = this.props;

        return (<Popup
            clave={"popup-baja-" + ajuste.Id}
            titulo="¿Está seguro que desea eliminar el movimiento?"
            ajuste={ajuste}
            eliminar={eliminarAjuste}
            usuarioModif={usuarioModif}>
            <a className="clickable none-text-decoration ingresoAjustes-icono-borrar" data-toggle="dropdown"></a>
        </Popup>);
    }
}

export default ButtonEliminar;